window.dtOvertimeRequest = function () {
  const dt_overtime_request = new DataTable('#overtime-request-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#overtime-request-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#overtime-request-datatable', 8); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[2, 'desc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "date" },
      { "data": "code" },
      { "data": "employee_fn" },
      { "data": "employee_ln" },
      { "data": "begin_time" },
      { "data": "end_time" },
      { "data": "total_hour" },
    ],
    columnDefs: [],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
      $('td:eq(4)', row).html(`${data.employee_fn} ${data.employee_ln}`);
      $('td:eq(4)', row).attr('colspan', 2);
      $('td:eq(5)', row).remove()
    },
  });

  dtFinalTouch()
}